export type BulkVariationOpeningPoint = 'addToCart' | 'customizerOpening' | 'quantityChip';

export const DEFAULT_BULK_VARIATION_OPENING_POINT: BulkVariationOpeningPoint = 'addToCart';

export const getBulkVariationOpeningPoints = (openingPoints?: BulkVariationOpeningPoint[]): BulkVariationOpeningPoint[] =>
    openingPoints && openingPoints.length > 0 ? [...openingPoints] : [DEFAULT_BULK_VARIATION_OPENING_POINT];
